var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',[_c('v-system-bar',[_vm._v("Errors")]),_c('LogDataTable',{attrs:{"items":_vm.items,"search":_vm.search,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }